<template>
  <div class="table_c">
    <div class="table_all" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
      <swiper class="swiper" ref="mySwiper" :options="swiperOption">
        <swiper-slide class="swiperItem" v-for="(item,index) in swiperList" :key="index">
          <el-table :data="item" border style="width: 100%;" :row-style="getRowClass" :header-row-style="getRowClass" :header-cell-style="getRowClass" :cell-style="getRowClass">
            <plt-table-dict-col prop="memberId" label="区域" namespace="bizObjects" id="member" :width="200" />
            <el-table-column prop="beginBillingAmount" label="转入数"></el-table-column>
            <el-table-column prop="beginBillingProportion" label="转入占比">
              <template slot-scope="scope">
                {{scope.row.beginBillingProportion?(scope.row.beginBillingProportion*100).toFixed(2) + '%':'0%'}}
              </template>
            </el-table-column>
            <el-table-column prop="deliverOutAmount" label="转回数"></el-table-column>
            <el-table-column prop="deliverOutProportion" label="转回占比">
              <template slot-scope="scope">
                {{scope.row.deliverOutProportion?(scope.row.deliverOutProportion*100).toFixed(2) + '%':'0%'}}
              </template>
            </el-table-column>
            <el-table-column prop="stopBillingAmount" label="退租数"></el-table-column>
            <el-table-column prop="stopBillingProportion" label="退租占比">
              <template slot-scope="scope">
                {{scope.row.stopBillingProportion?(scope.row.stopBillingProportion*100).toFixed(2) + '%':'0%'}}
              </template>
            </el-table-column>
          </el-table>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: { Swiper, SwiperSlide },
  name: "dk-table",
  props: {
    swiperList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      swiperOption: {
        // loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        on: {
          click: (e) => {
            /* loop模式下会在slides前后复制若干个 slide 但是这个复制只是针对 dom 不会带上事件的  
             所以不能在dom上 直接绑定事件   绑定则无效
             父组件选择器 弹窗打开后 点击swiper不会关掉，因此需要手动关闭
             */
            this.$parent.$parent.$refs[
              "dkTableDatePickerRef"
            ].pickerVisible = false;
            this.$parent.$parent.$refs[
              "dknowDatePickerRef"
            ].pickerVisible = false;
            this.$parent.$parent.$refs[
              "dkDownDatePickerRef"
            ].pickerVisible = false;
            this.$parent.$parent.$refs["dkDownSelectRef"].pickerVisible = false;
          },
        },
      },
    };
  },
  mounted() {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {
    swiperList: {
      handler: function (newData) {
        this.swiperList = newData;
        console.log(this.swiperList);
      },
      immediate: true,
      deep: true, //深度监听设置为 true
    },
  },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background: transparent;border:none;font-weight:400;";
    },
    on_bot_enter() {
      this.swiper.autoplay.stop();
    },
    on_bot_leave() {
      this.swiper.autoplay.start();
    },
  },
};
</script>

<style scoped lang="scss">
.table_c {
  padding: 15px 20px 0 20px;
}
.tebale_card {
  background: transparent;
}
::v-deep .el-table,
.el-table__expanded-cell {
  background: transparent;
  color: #fff !important;
  // border-radius: 20px;
  border: 1px solid transparent;
}
::v-deep .el-table tr {
  background: transparent;
  color: #fff;
}
::v-deep .el-table th > .cell {
  color: #fff;
}
::v-deep
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: #c3e4e738 !important;
  // cursor: pointer;
}
::v-deep .el-table--border::after,
.el-table--group::after,
.el-table::before {
  border: none;
  background: none;
}
</style>